import { DataBean } from "../DataBean";

export class BusinessType extends DataBean {
    
    


    public async getBusinessTypeCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("FinanceCore", "java.util.List_getBusinessTypeCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
  

}